<h2 mat-dialog-title class="text-xl font-semibold mb-4">Dashboard Filter</h2>
<mat-dialog-content>
	<form [formGroup]="filterForm" class="space-y-4">
		<mat-form-field class="w-full" *ngIf="(roleType === 'super_admin') && (app === 'Jotto')">
			<mat-label>Projects</mat-label>
			<mat-select formControlName="projectIds" multiple>
				<mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field class="w-full" *ngIf="(app === 'Jotto')">
			<mat-label>Channels</mat-label>
			<mat-select formControlName="channelIds" multiple>
				<mat-option *ngFor="let channel of channels" [value]="channel.id">{{ channel.name }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field class="w-full" *ngIf="app === 'Jotto'">
			<mat-label>Notifications</mat-label>
			<mat-select formControlName="notificationIds" multiple>
				<mat-option *ngFor="let notification of notifications" [value]="notification.id">{{ notification.title }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field class="w-full" *ngIf="app === 'Tobacco Atlas'">
			<mat-label>Country</mat-label>
			<mat-select formControlName="countryIds" multiple>
				<mat-option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-progress-bar *ngIf="loading" mode="indeterminate" class="my-4"></mat-progress-bar>
		<mat-form-field class="w-full">
			<mat-label>Start Date</mat-label>
			<input matInput [matDatepicker]="startPicker" formControlName="startDate" />
			<mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
			<mat-datepicker #startPicker></mat-datepicker>
		</mat-form-field>
		<mat-form-field class="w-full">
			<mat-label>End Date</mat-label>
			<input matInput [matDatepicker]="endPicker" formControlName="endDate" />
			<mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
			<mat-datepicker #endPicker></mat-datepicker>
		</mat-form-field>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-end space-x-2">
	<button mat-button (click)="onCancel()">Cancel</button>
	<button mat-button color="primary" (click)="onApply()">Apply</button>
</mat-dialog-actions>
